import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoIosClose, IoMdDownload } from "react-icons/io";
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from "../../../components/Loader";
// import Loader from "../../components/Loader";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment'
import { useHistory } from 'react-router';
import getExcel from "../../../_services/ExcelUtility";
import { Footer } from "../../../components/Footer";
const SalesReportSourceDataMonthly = () => {
    const fileName = 'Sales Report Source Data';
    const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
    const userData = JSON.parse(localStorage.getItem('userData'));
    const history = useHistory();
    const [salesReporSourceData, setSalesReporSourceData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    // excel Headers
    const excelColumns = [
        
        {
            Header: "Distributor Name",
            accessor: "DistributorName",
            filter: "DistributorName",
            sortType: "basic",
            width:140,
        },
        {
            Header: "Distribution Location (state abbreviation)",
            accessor: "DistributionLocationState",
            filter: "DistributionLocationState",
            sortType: "basic",
        },
        {
            Header: "Report Date",
            accessor: "ReportDate",
            filter: "ReportDate",
            sortType: "basic",
            width:110,
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        }, {
            Header: "Cust ID#",
            accessor: "CustID",
            filter: "CustID",
            sortType: "basic",
            width:95,
        }, {
            Header: "Cust GPO or HRSA ID# (when applicable)",
            accessor: "CustPHSID",
            filter: "CustPHSID",
            sortType: "basic",
        },
        {
            Header: "Cust Name",
            accessor: "CustName",
            filter: "CustName",
            sortType: "basic",
            width:300,
        },
        {
            Header: "Cust Address",
            accessor: "CustAddress",
            filter: "CustAddress",
            sortType: "basic",
            width:250,
        },
        {
            Header: "Cust City",
            accessor: "CustCity",
            filter: "CustCity",
            sortType: "basic",
            width:90,
        },
        {
            Header: "Cust State",
            accessor: "CustState",
            filter: "CustState",
            sortType: "basic",
            width:90,
        },
        {
            Header: "Cust Zip",
            accessor: "CustZip",
            filter: "CustZip",
            sortType: "basic",
            width:90,
        },
        {
            Header: "Customer's Invoice#",
            accessor: "CustomersInvoice",
            filter: "CustomersInvoice",
            sortType: "basic",
        },
        {
            Header: "Customer's Invoice Date",
            accessor: "CustomersInvoiceDate",
            filter: "CustomersInvoiceDate",
            sortType: "basic",
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        },
        {
            Header: "Product NDC-11",
            accessor: "ProductNDC",
            filter: "ProductNDC",
            sortType: "basic",
        },
        {
            Header: "Product Description",
            accessor: "ProductDescription",
            filter: "ProductDescription",
            sortType: "basic",
            width:200,
        },
        {
            Header: "Sale Qty",
            accessor: "SaleQTY",
            filter: "SaleQTY",
            sortType: "basic",
            width:120,
        },
        {
            Header: "Sale Qty UOM",
            accessor: "SaleQTYUOM",
            filter: "SaleQTYUOM",
            sortType: "basic",
            width:120,
        },
        {
            Header: "Dosage / Units",
            accessor: "DosagORUnitstabs30",
            filter: "DosagORUnitstabs30",
            sortType: "basic",
        },
        {
            Header: "Dosage / Units UOM",
            accessor: "DosageORUnitsUMO",
            filter: "DosageORUnitsUMO",
            sortType: "basic",
        },
        {
            Header: "Total IUs/EUs/Grams",
            accessor: "Totalcount",
            filter: "Totalcount",
            sortType: "basic",
        },
        {
            Header: "DAC per IU/EU/Gram",
            accessor: "AcquisitionCost",
            filter: "AcquisitionCost",
            sortType: "basic",
        },
        {
            Header: "Contract price per IU/EU/Gram (if applicable)",
            accessor: "ContractPrice",
            filter: "ContractPrice",
            sortType: "basic",
        },
        {
            Header: "Contract Reference#",
            accessor: "ContractReference",
            filter: "ContractReference",
            sortType: "basic",
        },
    
    ];

    useEffect(() => {
        getSalesReporSourceData();
    }, [])
    async function getSalesReporSourceData() {
        setLoading(true);
        let url = `api/Inbound/OutboundReportsData?FileProcessID=${outbounddata.FileProcessID}&ServiceTaskID=${outbounddata.ServiceTaskID}&FileTypeCode=SalesMonthly&TaskTypeCode=OctapharmaSales`;
        await _HttpServices
            .getData(url)
            .then((data) => {
                const SalesReporSourceDataResult = data.data;
                if(SalesReporSourceDataResult.length > 0){
                    SalesReporSourceDataResult.map((res) => { 
                        res.ReportDate = moment(res.ReportDate).format('MM/DD/YYYY'); 
                        res.CustomersInvoiceDate = moment(res.CustomersInvoiceDate).format('MM/DD/YYYY');
                        res.DosagORUnitstabs30 = (res.DosagORUnitstabs30*1).toFixed(2);
                        res.Totalcount = (res.Totalcount*1).toFixed(2);
                        // res.SaleQTY = (res.SaleQTY*1).toFixed(2);
                        res.AcquisitionCost = "$" + res.AcquisitionCost;
                        res.ContractPrice = "$" + (res.ContractPrice).toFixed(2);
                    })
                  }
                setSalesReporSourceData(SalesReporSourceDataResult);
                setLoading(false);
            })
            .catch((e) => {
                console.log(e);
                setLoading(false);
                setHasError(true);
            });
    }
    const EditRecords = () =>{
        localStorage.setItem("salesReporSourceData",JSON.stringify(salesReporSourceData));
        history.push("/OctapharmaSalesEdit")
    }
    return (
        <section className="content">
            <div className="page-title">
                <h2 className="h2">Sales Report Source Data</h2>
                {loading ? <Loader /> : null}
                <div>
                {salesReporSourceData.length > 0 &&userData.RoleID === 1 &&
                 (outbounddata.FileSentStatus == "Sent" ? <Button type="submit" onClick={() =>EditRecords()}>Create Reversal</Button> :
                    <Button type="submit" onClick={() =>EditRecords()}>Edit Records</Button>
                    )}
                <Button type="submit" className="ml-2" onClick={() => getExcel(excelColumns,salesReporSourceData,fileName)}><IoMdDownload className="icon btn-icon" />Download Excel </Button>
                </div>
            </div>
            <Row>
                <Col md={12}>
                    <div className="card pt-2">
                        <div className="card-body">
                            <div className="inventory-grid">
                            {hasError ? <p>Error occurred. Unable to load Sales Report Source Data.</p> :
                                <Fragment>
                                    {salesReporSourceData.length > 0 ? (
                                        <ReactTable columns={excelColumns} data={salesReporSourceData} defaultPageSize={10} />
                                    ) : (
                                            <div className="no-data">No data found.</div>
                                        )}
                                </Fragment>
                            }
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
              <Col md={12} className="text-right mt-2">
                <Button
                  variant="danger"
                  type="button"
                  className="ml-3"
                   onClick={() => history.goBack()}
                >
                  <IoIosClose className="icon btn-icon" />
                  Cancel
                </Button>
              </Col>
            </Row>
            <Footer />
        </section>
    );


}

export default SalesReportSourceDataMonthly;